module.exports = __webpack_public_path__ + "img/logo-Osai-RGB.bed2ee63.png";